/* ------------------------------------------------------------------
   Mr Football - BLACK NOVEMBER offer box (Nov 2026).
   Markup and styling in snippets/mf-bfn.liquid, which replaces the
   hat-trick builder on every jersey product page while the sale runs.

   FORKED FROM assets/mf-bundle.js (the hat-trick builder). Catalogue
   loading, search, inPool() and the name & number bar are the same code
   - read that file's header for why they work the way they do. That file
   is left untouched so the hat-trick can come back in January.

   ================================================================
   THE OFFER - ALL AUTOMATIC DISCOUNTS, NO CODE
   ================================================================
     1 jersey      20% off          DiscountAutomaticNode/1865330917557
     2+ jerseys    30% off each     DiscountAutomaticNode/1865330950325
     free gift     1 x `black-november-free-gift` at 100% off with
                   2+ jerseys       DiscountAutomaticNode/1865340387509
     free delivery on 2+ items      DiscountAutomaticNode/1865331015861
   The jersey discounts are scoped to the `hat-trick` collection, so
   inPool() must keep mirroring that collection's rule (see mf-bundle.js).
   PCT below must equal the discounts. Change both together.

   The multi-jersey option starts at 2 slots and "+ Add another jersey"
   grows it up to MAX_SLOTS, all on the product page - the owner does not
   want shoppers sent anywhere else. Every jersey is 30% off; the gift
   stays one per order (usesPerOrderLimit 1 on the discount).

   PRICES ARE COMPUTED THE WAY SHOPIFY DOES: per cart LINE, rounded to
   the cent. Same variant + same print = one line, so lines() groups the
   picks before doing the maths and the page matches checkout.

   AFTER ADDING, THE THEME'S CART DRAWER OPENS. Never redirect to /cart
   (owner's normal flow is the drawer - lesson from 2026-11-01).
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfBfn) { return; }
  window.__mfBfn = true;

  var PCT = { '1': 20, '2': 30 };
  var DELIVERY = 400;
  var NN_VALUE = 500;      /* name & number shown as a $5 extra (owner's call) */
  var MAX_SLOTS = 2;        /* fixed at 2 - more jerseys = buy the offer again (owner) */

  var CATS = [
    { key: 'mens',  label: "Men's kits",    handle: 'new-releases' },
    { key: 'kids',  label: "Kids' kits",    handle: 'kid' },
    { key: 'women', label: "Women's kits",  handle: 'women' },
    { key: 'retro', label: 'Retro kits',    handle: 'retro-kits' }
  ];

  /* Mirrors TITLE NOT_CONTAINS on the hat-trick collection. */
  var EXCLUDE = ['tracksuit', 'shorts', 'gloves', 'cleats', 'turf', 'shin',
                 'socks', 'mystery', 'scarf', 'windbreaker', 'bodysuit', 'matchball'];
  var MIN_CENTS = 2998;  /* GREATER_THAN 29.98 - lowered 2026-11-02 so the $29.99 women's kits count */
  var MAX_CENTS = 4501;
  var PAGE_SIZE = 50;
  var NN_KEY = 'Enter Name & Number (FREE)';

  var root, modal, self = null;
  var gifts = [];
  var gift = null;          /* { id, title, img, price } */
  var tier = '2';
  var multi = 2;            /* slots in the 2+ option */
  var picks = [];
  var activeSlot = 0;
  var activeCat = 'mens';
  var store = {};
  var hydrated = {};
  var searchTimer = null;
  var searchTerm = '';

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function inPool(p) {
    var t = String(p.title || '').toLowerCase();
    for (var i = 0; i < EXCLUDE.length; i++) {
      if (t.indexOf(EXCLUDE[i]) !== -1) { return false; }
    }
    var tags = p.tags || [];
    for (var j = 0; j < tags.length; j++) {
      if (String(tags[j]).toLowerCase() === 'no-hat-trick') { return false; }
    }
    var vs = p.variants || [];
    for (var k = 0; k < vs.length; k++) {
      if (!vs[k].available) { continue; }
      var c = Math.round(parseFloat(vs[k].price) * 100);
      if (c > MIN_CENTS && c < MAX_CENTS) { return true; }
    }
    return false;
  }

  function normalise(p, centsAlready) {
    var img = '';
    if (p.images && p.images.length) { img = p.images[0].src || p.images[0]; }
    else if (p.featured_image) { img = p.featured_image; }
    return {
      handle: p.handle,
      title: p.title,
      img: img,
      variants: (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
        return { id: v.id, title: v.title, price: centsAlready ? v.price : Math.round(parseFloat(v.price) * 100) };
      })
    };
  }

  /* ================= data ================= */

  function bucket(key) {
    if (!store[key]) { store[key] = { items: [], page: 1, done: false, loading: false }; }
    return store[key];
  }

  function loadPage(key) {
    var b = bucket(key);
    if (b.loading || b.done) { return Promise.resolve(b); }
    var cat = CATS.filter(function (c) { return c.key === key; })[0];
    if (!cat) { return Promise.resolve(b); }
    b.loading = true;
    renderList();
    return fetch('/collections/' + cat.handle + '/products.json?limit=' + PAGE_SIZE + '&page=' + b.page,
                 { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var got = (data && data.products) || [];
        if (got.length < PAGE_SIZE) { b.done = true; }
        b.page += 1;
        got.forEach(function (p) { if (inPool(p)) { b.items.push(normalise(p, false)); } });
        b.loading = false;
        renderList();
        if (!b.done && b.items.length < 12) { return loadPage(key); }
        return b;
      })
      .catch(function () { b.loading = false; b.done = true; renderList(); return b; });
  }

  function hydrate(handle) {
    if (hydrated[handle] !== undefined) { return Promise.resolve(hydrated[handle]); }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw 0; } return r.json(); })
      .then(function (p) {
        hydrated[handle] = inPool({
          title: p.title,
          tags: p.tags,
          variants: (p.variants || []).map(function (v) {
            return { available: v.available, price: (v.price / 100).toFixed(2) };
          })
        }) ? normalise(p, true) : null;
        return hydrated[handle];
      })
      .catch(function () { hydrated[handle] = null; return null; });
  }

  function runSearch(term) {
    searchTerm = term;
    if (term.length < 2) { renderList(); return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide',
          { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var hits = ((d.resources || {}).results || {}).products || [];
        return Promise.all(hits.map(function (h) { return hydrate(h.handle); }));
      })
      .then(function (list) {
        if (searchTerm !== term) { return; }
        store.__search = { items: list.filter(Boolean), done: true, loading: false, page: 1 };
        renderList();
      })
      .catch(function () {
        store.__search = { items: [], done: true, loading: false, page: 1 };
        renderList();
      });
  }

  function lookupVariants(p) {
    if (p.variants && p.variants.length) { return p.variants; }
    for (var k in store) {
      if (!store[k] || !store[k].items) { continue; }
      for (var i = 0; i < store[k].items.length; i++) {
        if (store[k].items[i].handle === p.handle) { return store[k].items[i].variants; }
      }
    }
    return hydrated[p.handle] ? hydrated[p.handle].variants : [];
  }

  /* ================= maths ================= */

  function slots() { return tier === '1' ? 1 : multi; }

  function fit() {
    while (picks.length < slots()) { picks.push(null); }
    if (!picks[0] && self) { picks[0] = selfPick(); }
  }

  function active() { fit(); return picks.slice(0, slots()); }

  function selfPick() {
    return { handle: self.handle, title: self.title, img: self.img, variants: self.variants,
             variantId: null, size: '', price: 0, isSelf: true };
  }

  function printText(p) {
    if (!p) { return ''; }
    var name = String(p.nnName || '').trim().toUpperCase();
    var num = String(p.nnNum || '').trim();
    return (name + ' ' + num).replace(/\s+/g, ' ').trim();
  }

  function lines() {
    var map = {}, out = [];
    active().forEach(function (p) {
      if (!p || !p.variantId) { return; }
      var key = p.variantId + '|' + printText(p);
      if (!map[key]) { map[key] = { price: p.price, qty: 0 }; out.push(map[key]); }
      map[key].qty += 1;
    });
    return out;
  }

  function totals() {
    var gross = 0, net = 0;
    lines().forEach(function (l) {
      var t = l.price * l.qty;
      gross += t;
      net += t - Math.round(t * PCT[tier] / 100);
    });
    return { gross: gross, net: net };
  }

  function after(cents, pct) { return cents - Math.round(cents * pct / 100); }
  function ready() { return active().every(function (p) { return p && p.variantId; }); }

  /* The price a slot would cost before a size is chosen: its cheapest
     variant, or this jersey's, or a standard $34.99 kit. */
  function basePrice(p) {
    if (p && p.variantId) { return p.price; }
    var vs = p ? lookupVariants(p) : (self ? self.variants : []);
    if (vs && vs.length) { return vs.reduce(function (m, v) { return Math.min(m, v.price); }, vs[0].price); }
    return 3499;
  }

  /* ================= render ================= */

  function renderTiers() {
    root.querySelectorAll('[data-bfn-tier]').forEach(function (el) {
      var mine = el.getAttribute('data-bfn-tier') === tier;
      el.setAttribute('aria-checked', mine ? 'true' : 'false');
      var panel = el.parentNode.querySelector('[data-bfn-panel]');
      if (panel) { panel.hidden = !mine; }
      el.parentNode.classList.toggle('is-on', mine);
    });
    root.querySelectorAll('[data-bfn-slots]').forEach(function (box) {
      if (box.getAttribute('data-for') !== tier) { box.innerHTML = ''; }
    });
  }

  function nnBar(p, i) {
    return '<span class="mfbfn__nn">' +
      '<span class="mfbfn__nn-tag">Name &amp; number <b>Free</b></span>' +
      '<span class="mfbfn__nn-fields">' +
        '<input type="text" class="mfbfn__nn-name" data-bfn-nn-name="' + i + '" maxlength="14" placeholder="Name" autocomplete="off" spellcheck="false" value="' + esc(p.nnName || '') + '" aria-label="Name to print on ' + esc(p.title) + '">' +
        '<input type="text" class="mfbfn__nn-num" data-bfn-nn-num="' + i + '" maxlength="2" inputmode="numeric" placeholder="No." autocomplete="off" value="' + esc(p.nnNum || '') + '" aria-label="Number to print on ' + esc(p.title) + '">' +
      '</span>' +
    '</span>';
  }

  function slotHtml(p, i) {
    var rm = (tier === '2' && i >= 2)
      ? '<button type="button" class="mfbfn__rm" data-bfn-rm="' + i + '">Remove</button>' : '';
    if (!p) {
      return '<div class="mfbfn__slot">' +
        '<span class="mfbfn__ph">' + (i + 1) + '</span>' +
        '<span class="mfbfn__slot-main"><span class="mfbfn__slot-empty">Jersey ' + (i + 1) + '</span></span>' +
        '<span class="mfbfn__slot-right"><button type="button" class="mfbfn__choose" data-bfn-open="' + i + '">Choose</button>' + rm + '</span>' +
        '</div>';
    }
    var sizes = lookupVariants(p).map(function (v) {
      return '<option value="' + v.id + '"' + (String(v.id) === String(p.variantId) ? ' selected' : '') + '>' + esc(v.title) + '</option>';
    }).join('');
    var price = p.variantId
      ? '<span class="mfbfn__price"><s>' + money(p.price) + '</s><b>' + money(after(p.price, PCT[tier])) + '</b></span>'
      : '';
    return '<div class="mfbfn__slot">' +
      (p.img ? '<img class="mfbfn__thumb" src="' + esc(p.img) + '" alt="" loading="lazy" width="48" height="48">'
             : '<span class="mfbfn__ph">' + (i + 1) + '</span>') +
      '<span class="mfbfn__slot-main">' +
        '<span class="mfbfn__slot-title">' + esc(p.title) + (p.isSelf ? ' <em>this jersey</em>' : '') + '</span>' +
        '<select class="mfbfn__size" data-bfn-size="' + i + '" aria-label="Size for ' + esc(p.title) + '">' +
          '<option value="">Select size</option>' + sizes +
        '</select>' +
        (p.variantId ? nnBar(p, i) : '') +
      '</span>' +
      '<span class="mfbfn__slot-right">' + price +
        (p.isSelf ? '' : '<button type="button" class="mfbfn__swap" data-bfn-open="' + i + '">Change</button>') + rm +
      '</span>' +
    '</div>';
  }

  function renderGifts() {
    var box = root.querySelector('[data-bfn-gifts]');
    if (box) {
      box.innerHTML = gifts.map(function (g, i) {
        var on = gift && gift.id === g.id;
        return '<button type="button" class="mfbfn__gift' + (on ? ' is-on' : '') + '" data-bfn-gift="' + i + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          (g.img ? '<img src="' + esc(g.img) + '" alt="" loading="lazy" width="60" height="60">' : '') +
          '<span class="mfbfn__gift-t">' + esc(g.title) + '</span>' +
          '<span class="mfbfn__gift-p"><s>' + money(g.price) + '</s> FREE</span>' +
        '</button>';
      }).join('');
    }
    var lab = root.querySelector('[data-bfn-gift-name]');
    if (lab) { lab.textContent = gift ? gift.title : 'gift'; }
    var was = root.querySelector('[data-bfn-gift-was]');
    if (was) { was.textContent = gift ? money(gift.price) : ''; }
    var im = root.querySelector('[data-bfn-gift-img]');
    var sv = root.querySelector('[data-bfn-gift-svg]');
    if (im && gift && gift.img) { im.src = gift.img; im.hidden = false; if (sv) { sv.hidden = true; } }
  }

  /* Header prices on both options, from the real picks where there are
     some. The 2+ header always quotes two jerseys - the headline deal -
     and its badge is capped at 50% because that is what is advertised. */
  function renderHeads() {
    var a = basePrice(picks[0]);
    var b = picks[1] ? basePrice(picks[1]) : a;
    var g = gift ? gift.price : 0;
    var one = root.querySelector('[data-bfn-head="1"]');
    if (one) { one.innerHTML = '<s>' + money(a) + '</s> ' + money(after(a, PCT['1'])); }
    var pay2 = after(a, PCT['2']) + after(b, PCT['2']);
    var base2 = a + b + g + DELIVERY + NN_VALUE;
    var two = root.querySelector('[data-bfn-head="2"]');
    if (two) { two.innerHTML = '<s>' + money(base2) + '</s> ' + money(pay2); }
    var badge = root.querySelector('[data-bfn-pct]');
    if (badge) { badge.textContent = '50% OFF'; }   /* fixed, owner's call */
  }

  function renderSum() {
    var out = root.querySelector('[data-bfn-total][data-for="' + tier + '"]');
    if (!out) { return; }
    var missing = active().filter(function (p) { return !p || !p.variantId; }).length;
    if (missing) {
      out.innerHTML = '<span class="mfbfn__todo">' +
        (missing === 1 && active()[0] && !active()[0].variantId && tier === '1' ? 'Choose your size' :
          missing + (missing === 1 ? ' more to choose' : ' more to choose')) + '</span>';
      return;
    }
    var t = totals();
    var extra = tier === '2' ? ((gift ? gift.price : 0) + DELIVERY + NN_VALUE) : 0;
    out.innerHTML = '<span class="mfbfn__pay">You pay ' + money(t.net) + '</span>' +
      '<span class="mfbfn__save">You save ' + money(t.gross - t.net + extra) + '</span>' +
      '';
  }

  function renderSlots() {
    fit();
    var box = root.querySelector('[data-bfn-slots][data-for="' + tier + '"]');
    if (box) { box.innerHTML = active().map(slotHtml).join(''); }
    var ex = root.querySelector('[data-bfn-extras]');
    if (ex) { ex.classList.toggle('is-black', tier === '2'); }
    var addBtn = root.querySelector('[data-bfn-addslot]');
    if (addBtn) { addBtn.hidden = multi >= MAX_SLOTS; }
    renderHeads();
    renderSum();
    var cta = root.querySelector('[data-bfn-add][data-for="' + tier + '"]');
    if (cta) {
      var ok = ready();
      cta.disabled = !ok;
      cta.textContent = ok
        ? (tier === '2' ? 'Add 2 jerseys + free gift' : 'Add to cart')
        : (tier === '2' ? 'Choose your jerseys' : 'Choose your size');
    }
  }

  function renderTabs() {
    var wrap = modal.querySelector('[data-bfn-tabs]');
    wrap.innerHTML = CATS.map(function (c) {
      return '<button type="button" class="mfbfn__tab" data-bfn-cat="' + c.key + '" aria-selected="' +
        (c.key === activeCat && !searchTerm ? 'true' : 'false') + '">' + esc(c.label) + '</button>';
    }).join('');
  }

  function renderList() {
    if (!modal) { return; }
    var list = modal.querySelector('[data-bfn-list]');
    var searching = searchTerm.length >= 2;
    var b = searching ? (store.__search || { items: [], loading: true, done: false }) : bucket(activeCat);
    var pct = PCT[tier];
    var rows = b.items.map(function (p) {
      var opts = p.variants.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>';
      }).join('');
      var from = p.variants.length ? p.variants[0].price : 0;
      return '<div class="mfbfn__row" data-handle="' + esc(p.handle) + '">' +
        (p.img ? '<img class="mfbfn__row-img" src="' + esc(p.img) + '" alt="" loading="lazy" width="54" height="54">' : '<span class="mfbfn__ph">·</span>') +
        '<span class="mfbfn__row-main">' +
          '<span class="mfbfn__row-title">' + esc(p.title) + '</span>' +
          '<span class="mfbfn__row-price"><s>' + money(from) + '</s> ' + money(after(from, pct)) + '</span>' +
          '<select class="mfbfn__row-size" aria-label="Size"><option value="">Select size</option>' + opts + '</select>' +
        '</span>' +
        '<button type="button" class="mfbfn__pick" disabled>Choose</button>' +
        '</div>';
    }).join('');
    if (!rows) {
      rows = '<p class="mfbfn__empty">' +
        (b.loading ? 'Loading jerseys&hellip;' : (searching ? 'Nothing in the offer matches that.' : 'No jerseys here.')) + '</p>';
    }
    var more = (!searching && !b.done && !b.loading) ? '<button type="button" class="mfbfn__more" data-bfn-more>Load more</button>' : '';
    var spin = b.loading && b.items.length ? '<p class="mfbfn__empty">Loading&hellip;</p>' : '';
    list.innerHTML = rows + spin + more;
  }

  function renderAll() { renderTiers(); renderGifts(); renderSlots(); }

  /* ================= cart ================= */

  function openDrawer() {
    try {
      var cfg = JSON.parse((document.getElementById('cart-config') || {}).innerHTML || '{}');
      var st = window.Shopify && window.Shopify.theme;
      if (st && st.cart && st.ajaxCart && cfg.cart_action === 'drawer') {
        st.cart.getCart().then(function (c) {
          st.ajaxCart.updateView(cfg, c);
          st.ajaxCart.showDrawer(cfg);
          renderSlots();
        }).catch(function () { window.location.href = '/cart'; });
        return;
      }
    } catch (e) {}
    window.location.href = '/cart';
  }

  /* The theme's own "Enter Name & Number (FREE)" field on this page. If
     the shopper typed there instead of in jersey 1's bar, use it. */
  function themeNN() {
    var c = document.querySelector('input[name^="properties[Enter Name"]');
    return c && c.value && c.value.trim() ? c.value.trim() : '';
  }

  function addBundle(btn) {
    if (!ready()) { renderSlots(); return; }
    var items = active().map(function (p, i) {
      var item = { id: parseInt(p.variantId, 10), quantity: 1 };
      var text = printText(p);
      if (!text && i === 0 && p.isSelf) { text = themeNN(); }
      if (text) { item.properties = {}; item.properties[NN_KEY] = text; }
      return item;
    });
    if (tier === '2' && gift && items.length >= 2) { var last = items[items.length - 1]; last.properties = last.properties || {}; last.properties['🎁 Free gift'] = gift.title; }
    var err = root.querySelector('[data-bfn-err]');
    if (err) { err.hidden = true; }
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { throw new Error('add failed'); }
      openDrawer();
    }).catch(function () {
      if (err) { err.hidden = false; }
      renderSlots();
    });
  }

  /* ================= modal ================= */

  function openModal(slot) {
    activeSlot = slot;
    searchTerm = '';
    var input = modal.querySelector('[data-bfn-search]');
    if (input) { input.value = ''; }
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    renderTabs();
    renderList();
    if (!bucket(activeCat).items.length) { loadPage(activeCat); }
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 80);
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ================= wiring ================= */

  function onClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }

    var inRoot = root.contains(t);
    var inModal = modal.contains(t);

    if (inRoot) {
      var tierEl = t.closest('[data-bfn-tier]');
      if (tierEl) { ev.preventDefault(); tier = tierEl.getAttribute('data-bfn-tier'); renderAll(); return; }

      if (t.closest('[data-bfn-upgrade]')) { ev.preventDefault(); tier = '2'; renderAll(); return; }

      if (t.closest('[data-bfn-addslot]')) {
        ev.preventDefault();
        if (multi < MAX_SLOTS) {
          multi += 1;
          fit();
          renderSlots();
          openModal(multi - 1);
        }
        return;
      }

      var rm = t.closest('[data-bfn-rm]');
      if (rm) {
        ev.preventDefault();
        var ri = parseInt(rm.getAttribute('data-bfn-rm'), 10);
        if (ri >= 2 && multi > 2) { picks.splice(ri, 1); multi -= 1; renderSlots(); }
        return;
      }

      var g = t.closest('[data-bfn-gift]');
      if (g) {
        ev.preventDefault();
        var gg = gifts[parseInt(g.getAttribute('data-bfn-gift'), 10)];
        if (gg) { gift = gg; renderGifts(); renderSlots(); }
        return;
      }

      var open = t.closest('[data-bfn-open]');
      if (open) { ev.preventDefault(); openModal(parseInt(open.getAttribute('data-bfn-open'), 10)); return; }

      var add = t.closest('[data-bfn-add]');
      if (add && !add.disabled) { ev.preventDefault(); addBundle(add); }
      return;
    }

    if (!inModal) { return; }

    if (t.closest('[data-bfn-close]') || t === modal) { ev.preventDefault(); closeModal(); return; }

    var tab = t.closest('[data-bfn-cat]');
    if (tab) {
      ev.preventDefault();
      activeCat = tab.getAttribute('data-bfn-cat');
      searchTerm = '';
      var si = modal.querySelector('[data-bfn-search]');
      if (si) { si.value = ''; }
      renderTabs();
      renderList();
      if (!bucket(activeCat).items.length) { loadPage(activeCat); }
      return;
    }

    if (t.closest('[data-bfn-more]')) { ev.preventDefault(); loadPage(activeCat); return; }

    var pick = t.closest('.mfbfn__pick');
    if (pick) {
      ev.preventDefault();
      var row = pick.closest('.mfbfn__row');
      var sel = row.querySelector('.mfbfn__row-size');
      if (!sel.value) { return; }
      var opt = sel.options[sel.selectedIndex];
      var prev = picks[activeSlot] || {};
      picks[activeSlot] = {
        handle: row.getAttribute('data-handle'),
        title: row.querySelector('.mfbfn__row-title').textContent,
        img: (row.querySelector('.mfbfn__row-img') || {}).src || '',
        variantId: sel.value,
        size: opt.textContent,
        price: parseInt(opt.getAttribute('data-price'), 10) || 0,
        nnName: prev.nnName || '',
        nnNum: prev.nnNum || ''
      };
      closeModal();
      renderSlots();
    }
  }

  function onChange(ev) {
    var t = ev.target;
    if (!t || !t.classList) { return; }
    if (t.classList.contains('mfbfn__row-size')) {
      t.closest('.mfbfn__row').querySelector('.mfbfn__pick').disabled = !t.value;
      return;
    }
    if (t.hasAttribute('data-bfn-size')) {
      var p = picks[parseInt(t.getAttribute('data-bfn-size'), 10)];
      if (!p) { return; }
      var v = lookupVariants(p).filter(function (x) { return String(x.id) === String(t.value); })[0];
      p.variantId = v ? v.id : null;
      p.size = v ? v.title : '';
      p.price = v ? v.price : 0;
      renderSlots();
    }
  }

  function onInput(ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute) { return; }
    var isNum = t.hasAttribute('data-bfn-nn-num');
    if (isNum || t.hasAttribute('data-bfn-nn-name')) {
      var pk = picks[parseInt(t.getAttribute(isNum ? 'data-bfn-nn-num' : 'data-bfn-nn-name'), 10)];
      if (!pk) { return; }
      if (isNum) {
        var digits = t.value.replace(/\D/g, '').slice(0, 2);
        if (t.value !== digits) { t.value = digits; }
        pk.nnNum = digits;
      } else {
        pk.nnName = t.value;
      }
      renderSum();   /* never re-render the inputs while typing */
      return;
    }
    if (!t.hasAttribute('data-bfn-search')) { return; }
    var val = t.value.trim();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      if (val.length < 2) { searchTerm = ''; renderTabs(); renderList(); return; }
      store.__search = { items: [], loading: true, done: false, page: 1 };
      searchTerm = val;
      renderTabs();
      renderList();
      runSearch(val);
    }, 250);
  }

  function init() {
    root = document.querySelector('[data-mf-bfn]');
    modal = document.querySelector('[data-bfn-modal]');
    if (!root || !modal) { return; }
    /* The sheet lives on <body> so no transformed ancestor traps it. */
    document.body.appendChild(modal);

    try { gifts = JSON.parse(root.getAttribute('data-bfn-gifts') || '[]'); } catch (e) { gifts = []; }
    gift = gifts.length ? gifts[0] : null;

    var rawSelf = root.getAttribute('data-bfn-self');
    if (rawSelf) {
      try {
        self = JSON.parse(rawSelf);
        self.variants = (self.variants || []).filter(function (v) { return v.available; });
      } catch (e) { self = null; }
    }

    /* On the Black November deal page nothing moves the box (no quantity
       block for place() to anchor on), so it would sit above the benefits.
       Put it straight after them, the same order as a jersey page. */
    /* Benefits first, then the offer - on every template, not only where mf-kit-builder.js runs place(). */
    {
      var ben = document.querySelector('.product__section-details .mf-benefits');
      if (ben && ben.parentNode && (ben.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_PRECEDING)) { ben.parentNode.insertBefore(root, ben.nextElementSibling); }
    }

    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    document.addEventListener('input', onInput);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) { closeModal(); } });
    window.addEventListener('pageshow', function () { renderSlots(); });

    renderAll();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
